import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import App from './App';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ChatbotService from './pages/ChatbotService';
import VoiceService from './pages/VoiceService';
import EmailAutomation from './pages/EmailAutomation';
import SocialAutomation from './pages/SocialAutomation';
import TrainingWorkshop from './pages/TrainingWorkshop';
import Blog from './pages/Blog';
import MicroSaas from './pages/MicroSaas';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chatbot" element={<ChatbotService />} />
          <Route path="/voice-agent" element={<VoiceService />} />
          <Route path="/email-automation" element={<EmailAutomation />} />
          <Route path="/social-automation" element={<SocialAutomation />} />
          <Route path="/training" element={<TrainingWorkshop />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/micro-saas" element={<MicroSaas />} />
        </Routes>
      </Router>
    </AuthProvider>
  </StrictMode>
);